import api from '@/services/api/useCases.js'
import { immerable } from "immer"
import { useState } from 'react'
import { AgentPrincipalOrganisationUseCaseStatus } from '@/constants/use-case/index'
import { storeUseCase } from '@/utils/use-case-storage'

class UseCase {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.name = params.name
		this.description = params.description
		this.dataElements = params.dataElements
		this.personas = params.personas
		this.participants = params.participants
		this.status = params.status
		this.image = params.image
		this.contributes = params.contributes
		this.consumes = params.consumes
		this.provideOnBehalf = params.provideOnBehalf
		this.consumeOnBehalf = params.consumeOnBehalf
		this.approach = params.approach
		this.keyValueDrivers = params.keyValueDrivers
		this.participantDetails = params.participantDetails
		this.title = params.title
		this.enrolledParticipants = params.enrolledParticipants
		this.isAgentEnabled = params.isAgentEnabled
		this.agentStatus = params.agentStatus
		this.enableETR = params.enableETR
		this.etrIssuance = params.etrIssuance
	}
}

const useUseCases = () => {

	const [items, setItems] = useState([])
	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()
	const [currentPersona, setcurrentPersona] = useState();

	const [filterUseCase, setFilterUseCase] = useState([])

	async function fetch(parameter) {

		setLoading(true)

		const params = parameter ?? "";

		const [errorResponse, data] = await api.index({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(data.items)) {
			return setError('Use Case is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(entry => new UseCase(entry))
		storeUseCase(newItems)

		setItems(newItems)
		return newItems
	}

	async function find(parameter) {
		setLoading(true)
		const params = parameter ?? "";

		const [errorResponse, data] = await api.index({ params });


		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(data.items)) {
			return setError('Use Case is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(entry => new UseCase(entry))

		setItems(newItems)
		return newItems
	}

	async function findOne(parameter) {

		setLoading(true)
		const params = parameter ?? "";

		const [errorResponse, data] = await api.findOne(
			params
		)

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		return setcurrentPersona(data.usecases)
	}

	async function getFilterUseCase(parameter) {

		setLoading(true)
		const params = parameter ?? "";

		const [errorResponse, data] = await api.getUseCase(params)

		setLoading(false)

		if (errorResponse) {
			return setError('Use Case API has error')
		}

		const useCaseList = data?.map((item) => ({ id: item.useCaseId, name: item.useCaseTitle }))
		return setFilterUseCase(useCaseList)
	}

	function serialize(entry) {
		return {
			id: entry.id,
			name: entry.title,
			dataElements: entry.dataElements,
			personas: entry.personas,
			participants: entry.participants,
			status: entry.status,
			image: entry.image,
			contributes: entry.contributes,
			consumes: entry.consumes,
			provideOnBehalf: entry.provideOnBehalf,
			consumeOnBehalf: entry.consumeOnBehalf,
			description: entry.description,
			approach: entry.approach,
			keyValueDrivers: entry.keyValueDrivers,
			participantDetails: entry.participantDetails,
			title: entry.name,
			enrolledParticipants: entry.enrolledParticipants,
			isAgentEnabled: entry.isAgentEnabled,
			agentStatus: entry.agentStatus,
			enableETR: entry.enableETR,
			etrIssuance: entry.etrIssuance,
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		find,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		findOne,
		currentPersona,
		setcurrentPersona,
		filterUseCase,
		setFilterUseCase,
		getFilterUseCase,
		isAgentPrincipalEnabled
	}

}

export function isAgentPrincipalEnabled(agentStatus) {
	return agentStatus === AgentPrincipalOrganisationUseCaseStatus.ENABLED || agentStatus === AgentPrincipalOrganisationUseCaseStatus.PENDING_DISABLE_APPROVAL
}

export function isAgentPrincipalPendingApproval(agentStatus) {
	return agentStatus === AgentPrincipalOrganisationUseCaseStatus.PENDING_ENABLE_APPROVAL || agentStatus === AgentPrincipalOrganisationUseCaseStatus.PENDING_DISABLE_APPROVAL
}

export default useUseCases
